import type { FaireProductEntity } from "../../entity_types/product";

export const p_qy2pmxqf52: FaireProductEntity = {
  token: "p_qy2pmxqf52",
  type: "product",
  name: "Rooster Butter Dish \u2013 Farmhouse Ceramic Kitchen Decor",
  brandName: "Drew Derose Design",
  imageUrl:
    "https://cdn.faire.com/fastly/a091222c9389bace1d71434f43087131b1c855e32736a4f604f50684cab75d65.png",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2b1123ce85328fc9856b2de5676a2d3cff70e2c7043c87785686365ca55e351f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
